import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";


import { apiFetch } from "./apiFetch";

export async function getBarchartFinanceStatus(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/status", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  checkResponse(resp);
  return resp.json();
}

export async function disconnectBarchartFinance(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/disconnect", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  checkResponse(resp);
  return resp.json();
}

export async function startBarchartFinanceLogin(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/startLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to start Barchart login");
  }
  return data;
}

export async function completeBarchartFinanceLogin(accountId, userId, sessionId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/completeLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, sessionId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to save Barchart session");
  }
  return data;
}

export async function cancelBarchartFinanceLogin(accountId, userId, sessionId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/cancelLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, sessionId }),
  });
  checkResponse(resp);
  return resp.json();
}

export async function saveBarchartFinanceCookies(accountId, userId, cookies) {
  const resp = await apiFetch(serverInfo.serverUrl + "/barchartFinance/saveCookies", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, cookies }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to save Barchart cookies");
  }
  return data;
}
